/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { forwardRef, Ref, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Selection, Transforms } from 'slate';
import { Overlay, OverlayElement, OverlayExtendProps } from 'components/_new/Overlay';
import { Box, BoxSection } from 'components/_new/Box';
import { TableUtil } from '../../utils/table';
import { CustomEditor } from '../../types';
import './TableSelector.scss';

type TableSelectorProps = {
	editor: CustomEditor;
} & Pick<OverlayExtendProps, 'onOpenStateChange'>;

export const TableSelector = forwardRef(
	({ editor, onOpenStateChange }: TableSelectorProps, ref: Ref<OverlayElement>) => {
		const table = new TableUtil(editor);
		const overlayRef = useRef<OverlayElement>(null);
		const [selection, setSelection] = useState<Selection>(null);

		useImperativeHandle(ref, () => ({
			open: () => {
				//
			},
			close: () => {
				setTableData({
					row: 0,
					column: 0,
				});
			},
			isOpen: () => {
				return false;
			},
			toggle: (element) => {
				setSelection(editor.selection);
				if (overlayRef?.current) {
					overlayRef.current.toggle(element);
				}
			},
			getElement: () => overlayRef?.current?.getElement() || null,
		}));

		const [tableData, setTableData] = useState({
			row: 0,
			column: 0,
		});
		const [tableInput, setTableInput] = useState(
			Array.from({ length: 6 }, () =>
				Array.from({ length: 6 }, (v, i) => ({
					bg: 'lightGray',
					column: i,
				}))
			)
		);

		useEffect(() => {
			const newTable = Array.from({ length: 6 }, (obj, row) =>
				Array.from({ length: 6 }, (v, col) => ({
					bg: row + 1 <= tableData.row && col + 1 <= tableData.column ? 'orange' : 'lightgray',
					column: col,
				}))
			);
			setTableInput(newTable);
		}, [tableData]);

		const handleInsert = () => {
			if (selection) {
				Transforms.select(editor, selection);
			}
			setTableData({ row: -1, column: -1 });
			table.insertTable(tableData.row, tableData.column);
			overlayRef?.current?.close();
		};

		return (
			<Overlay ref={overlayRef} onOpenStateChange={onOpenStateChange}>
				<Box variant="white-bordered" className="editor-popup" dropShadow>
					<BoxSection>
						<span style={{ fontSize: '0.85em' }}>
							<i>{`Wstaw tabelę ${
								tableData.row >= 1 ? `${tableData.row} x ${tableData.column}` : ''
							}`}</i>
						</span>
						<div className="table-input">
							{tableInput.map((grp, row) =>
								grp.map(({ column, bg }, col) => (
									<div
										// eslint-disable-next-line react/no-array-index-key
										key={`${row}-${col}`}
										onClick={() => handleInsert()}
										onMouseOver={() => setTableData({ row: row + 1, column: column + 1 })}
										className="table-unit"
										style={{ border: `1px solid ${bg}` }}
									/>
								))
							)}
						</div>
					</BoxSection>
				</Box>
			</Overlay>
		);
	}
);
